module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAABDElEQVRYhe2W0Q2CMBRFr8Y5Gk0YgA2MG8gG8tmJ+IQNnMENGIBEwwSOYF4CSS0tlNdX/eH+AKXJOS20fdjy7+xS8TutjgBuRlOTVf3L7pdEoNOKwLXjVZlVfZNUYAY+5mTOxP7HcFifRU4gED6JiAAXTokWYMC/fsIoAQa8tJciexUw4Y3dyBKQgrMEJOGrBaThqwRSwIMFUsGDBFLCFwU6ra4A7qnglKWNiDaNdyq4V4CKiU6rOqv6FsAlQIIF9woAyOnYDJRgw5cEECARBZ8TOBv3Polo+JxAbj3bEoUEnDJZhkM1+/T0p8q2lACPOTjazNHTdNOoH8O1lYRTXAIELQjmquO3bBENgA/Zg4VIPWYqNAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/ic_btn_edit_press@2x.png
// module id = 727
// module chunks = 0